import { getRgObjectsOfType as t, RG_TYPE as r } from "@project-rouge/rg-core";
import { isAmenityTechSpace as i } from "../../queries/index.js";
import { getPerimeter as m } from "../index8.js";
const f = (e) => m(t(e, r.TechnicalSpace).filter(i));
export {
  f as getAmenitiesPerimeter
};
//# sourceMappingURL=index3.js.map
